import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import store from './reducers';

import reportWebVitals from './reportWebVitals';

import App from './App';

import { installAxiosInterceptors } from './tools/axios-setup';

import './stylesheets/app.scss';

// Install a global axios interceptor that bounces to /login on 401 from a
// non-auth endpoint, instead of silently leaving stores empty.
installAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
